import React, {useContext} from "react";
import {StepProps} from "../step-props";
import {forms} from "../forms";
import {MtplQuotation, Quotation} from "../../../model/quotation";
import {QuotationContext} from "../../../contexts/QuotationContext";
import {isSmartDrive} from "../../../utils/quotation";
import { useHotjar } from "../../../utils/hooks/useHotjar";

export const MtplVerificationStep = ({step}: StepProps) => {
    const {tarrificationProgram, saveTempValues, type} = useContext<QuotationContext<MtplQuotation>>(QuotationContext);
    const { trackHotjar} = useHotjar()

    const onVerify = (quotation: Quotation, paymentPageUrl: string) => {
        let event = isSmartDrive(tarrificationProgram) ? 'osago_emtpl_smart_identification' : 'osago_identification';
        console.log('Google Analytics Event = ' + event);
        // @ts-ignore
        window.dataLayer.push({'event': event});
        saveTempValues("expires_in", "1")

        trackHotjar("confirm-number", type );
        window.location.href = paymentPageUrl;
    };

    return (
        <>
            {step.forms.map(form => {
                return React.createElement(forms[form.code], {
                    key: form.code,
                    onVerify
                })
            })}
        </>
    );
};
